import { useEffect } from 'react'

// Deps
import { connect } from 'react-redux';
import { redirect } from 'controllers/navigator'

const mapStateToProps = (state, ownProps) => {
	return {
		userData: state.user.data,
	}
}

const Intro = (props) => {
	useEffect(() => {
		if(props.userData === false) {
			redirect({ to: 'login', replace: true});
		}
		else if(props.userData !== null) {
			if (window.localStorage.getItem('isTerminal') === '1') {
				redirect({to: 'dashboard', replace: true, base: 'terminal'});
			}
			else {
				redirect({to: 'dashboard', replace: true});
			}
		}
	}, [props.userData]);

	return false;
}

export default connect(mapStateToProps)(Intro);